import React, { useState, useEffect } from 'react';
import { handleExtendTimeFilterValue } from '@intelligence/utils/filterUtils';
import Filter from '@/pages/intelligence/components/Filter';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { RANGE_TIME as FILTER_RANGE_TIME } from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { DOUYIN_FILTER_DEFAULT_INPUT_LIST, DOUYIN_FILTER_DEFAULT_VALUE } from '../../douyinConfig';
import './index.scss';
import type { IBaseProps } from '@/pages/intelligence/types/common';
import type { IMobileStoreRankTopFilter, IStoreRankTopFilter } from '@/pages/intelligence/types/storeRank';
import { handleRangeMiniGameMoreFilterExtend } from '@intelligence/utils/dateUtils';

interface IDouyinGamesTopFilterProps extends IBaseProps {
  isOperate: boolean;
  morePagePath?: string;
  morePageSource?: string;
  filter: IStoreRankTopFilter | IMobileStoreRankTopFilter;
  onConfirm: (payload: IMobileStoreRankTopFilter) => void;
  onReset: () => void;
}

const DouyinGamesTopFilter: React.FC<IDouyinGamesTopFilterProps> = (props) => {
  const {
    isOperate,
    onConfirm,
  } = props;

  const { filterExtend: filterExtendTmp, setFilterExtend } = useFilterExtend({});

  const initialFormValue = (() => {
    if (!isOperate) return DOUYIN_FILTER_DEFAULT_VALUE;
    const filterExtend = handleRangeMiniGameMoreFilterExtend(filterExtendTmp);

    const rangeTimeFilterExtend = filterExtend[FILTER_RANGE_TIME];

    const rangeTimeDefault = DOUYIN_FILTER_DEFAULT_VALUE[FILTER_RANGE_TIME];
    return {
      [FILTER_RANGE_TIME]: {
        type: 'date',
        value: handleExtendTimeFilterValue({
          extendFilterValues: rangeTimeFilterExtend,
          defaultValue: rangeTimeDefault?.value,
        }),
      },
    };
  })();
  const [formValue, setFormValue] = useState(initialFormValue);

  useEffect(() => {
    setFormValue(initialFormValue);
  }, [filterExtendTmp, isOperate]);

  const handleFilterChange = (value: any, apiValue: any) => {
    setFormValue(value);
    const filterForm = {
      start_date: apiValue[FILTER_RANGE_TIME]?.start_date,
      end_date: apiValue[FILTER_RANGE_TIME]?.end_date,
    } as any;

    onConfirm?.(filterForm);
    setFilterExtend(apiValue);
  };

  return (
    <div className="dbi-store-rank-filter">
      <Filter
        filterKey="douyin-games-top-filter"
        inputList={DOUYIN_FILTER_DEFAULT_INPUT_LIST}
        needConfirm={false} // 不需要确认按钮，选择后直接触发
        onConfirm={handleFilterChange}
        showButton={false}
        value={formValue}
      />
    </div>
  );
};

export default DouyinGamesTopFilter;
